$(document).ready(function() {
  console.log('test1');
  $(".sidebar li:contains('Sale Exempt')").remove();
  $(".sidebar li:contains('On Sale')").remove();

  if ($('body').attr('id') === 'graphic-express-1970-boss-302-mustang-complete-stripe-decal-custom') {
    console.log('test2');
    $('#productSelect-product-template-option-0').prepend('<option value="" disabled="">SELECT AN OPTION</option>');
  }
});

function updateAddToCartButton() {
  console.log('--- updateAddToCartButton called ---');
  
  const productSelect = document.getElementById('productSelect-product-template-option-0');
  const colorSelect = document.getElementById('custom-color');
  const addToCartBtn = document.querySelector('.btn--add-to-cart');
  
  console.log('Product Select:', productSelect);
  console.log('Color Select:', colorSelect);
  console.log('Add to Cart Button:', addToCartBtn);
  
  if (!productSelect || !colorSelect || !addToCartBtn) {
    console.log('ERROR: One or more elements not found!');
    return;
  }
  
  const isProductDefault = productSelect.value === 'CUSTOM COLOR - NO RETURNS' 
  const isColorDefault = colorSelect.value === '' || 
                        colorSelect.value === 'Select a Color' ||
                        colorSelect.selectedIndex === 0;
  
  console.log('Product Select Value:', productSelect.value);
  console.log('Product Selected Index:', productSelect.selectedIndex);
  console.log('Is Product Default?', isProductDefault);
  
  console.log('Color Select Value:', colorSelect.value);
  console.log('Color Selected Index:', colorSelect.selectedIndex);
  console.log('Is Color Default?', isColorDefault);
  
  if (isProductDefault && isColorDefault) {
    console.log('DISABLING button - both selects are default');
    addToCartBtn.disabled = true;
    addToCartBtn.style.opacity = '0';
    addToCartBtn.style.cursor = 'not-allowed';
  } else {
    console.log('ENABLING button - at least one select has a value');
    addToCartBtn.disabled = false;
    addToCartBtn.style.opacity = '1';
    addToCartBtn.style.cursor = 'pointer';
  }
  
  console.log('Button disabled state:', addToCartBtn.disabled);
  console.log('--- End of updateAddToCartButton ---\n');
}

document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM Content Loaded - Setting up event listeners');
  
  const productSelect = document.getElementById('productSelect-product-template-option-0');
  const colorSelect = document.getElementById('custom-color');
  
  if (productSelect) {
    console.log('Adding change listener to product select');
    productSelect.addEventListener('change', updateAddToCartButton);
  } else {
    console.log('WARNING: Product select not found');
  }
  
  if (colorSelect) {
    console.log('Adding change listener to color select');
    colorSelect.addEventListener('change', updateAddToCartButton);
  } else {
    console.log('WARNING: Color select not found');
  }
  
  console.log('Running initial button state check');
  updateAddToCartButton();
});